import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import { getCookieValue, postToNativeApp } from "../common/helpers";
import { logout } from "../reducers/login.slice";
import { resetToInitial } from "../reducers/claimList.slice";
import { resetToInitialConfig } from "../reducers/config.slice";
import Constants from "../constants/Constants";
import { resetToInitialBeneficiaries } from "../reducers/beneficiaries.slice";

const Logout = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

    useEffect(() => {
      for (let key in localStorage) {
        if (localStorage.hasOwnProperty(key) && key !== Constants.Instance.ENABLE_BIOMETRICS) {
          localStorage.removeItem(key);
        }
      }
        sessionStorage.clear();
        
        dispatch(logout());
        dispatch(resetToInitial());
        dispatch(resetToInitialConfig());
        dispatch(resetToInitialBeneficiaries());
        if (getCookieValue("source") === "native") {
            postToNativeApp({
              logout: "logout",
            });
          }
        navigate("/")
    })
    return(<></>)
}
export default Logout;